import React from "react";

import { ExternalLink } from "./ExternalLink";
import { RouterLink } from "./RouterLink";

import { Link as MUILink } from '../../UI/Link';

import { IProps } from "./types";

export const Link: React.FC<IProps> = React.memo(props => {
  if (props.to) {
    return <RouterLink {...props as any} />; // TODO: remove any
  }

  if (props.href) {
    return <ExternalLink {...props as any} />; // TODO: remove any
  }

  return <MUILink {...props} />;
});
